import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login/login.service';
import { UsuarioService } from '../services/usuario.service';
import { SessionService } from '../services/session.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SweetMessage } from '../config/sweet-message';

@Component({
  selector: 'app-locked-login',
  templateUrl: './locked-login.component.html',
  styleUrls: ['./locked-login.component.css'],
  providers: [LoginService, UsuarioService]
})
export class LockedLoginComponent implements OnInit {
	public msgSweet: SweetMessage;

	constructor(
		public loginService: LoginService,
		private usuarioService: UsuarioService,
		private ss: SessionService,
		private NavRoute: Router,
	) { 
		this.msgSweet = new SweetMessage();
	}

	ngOnInit() {

	}

	auth(usuario, password){
		let data = {
			usuario: usuario,
			password: password
		};
		this.loginService.auth(data).subscribe(response => {
			sessionStorage.setItem('api-token', response.data.token);
			this.usuarioService.getByUser(data.usuario, "").subscribe(
				res => {
					this.ss.setData(res).then(()  => this.NavRoute.navigate(['desktop']));
				}
			);
		},
	err => {
		this.msgSweet.showMessage('error-message', "Error: " + err.json().message);
	});
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/locked-login/locked-login.component.ts